import { DropdownOption } from '@types';
import { isEmpty } from 'lodash';
import i18n from 'i18next';
import { PLEASE_ENTER_THE_VALUE } from '@translations';
import { countryCode } from '../config/countryCode';
import { LANGUAGE_PICKER_EXCLUSION } from '@constants';
export const findSelectedOption = (value: any, options: DropdownOption[]) => {
  const selectedOption = options.filter((option: any) => option.value === value)[0];
  return selectedOption;
};

export const isValid = (...fields: any[]) => {
  let fieldsValid = true;
  for (let field of fields) {
    if (isEmpty(field)) {
      fieldsValid = false;
      break;
    }
  }
  return fieldsValid;
};

export const langCodeRipper = (code: string) => {
  return code.indexOf('-') > -1 && !LANGUAGE_PICKER_EXCLUSION.includes(code) ? code.split('-')[0] : code;
};

const checkString = (word: string, matchString: string) => {
  let rStatus = false
  if (word && matchString && matchString.includes(word))
    rStatus = true

  return rStatus
}

export const checkWordInString = (word: string, matchString: string) => {
  let returnStatus = false
  if (word.indexOf(',') > -1) {
    var words = word.split(',')
    for (let elem of words) {
      returnStatus = checkString(elem, matchString)
      if (returnStatus) break;
    }
  } else {
    returnStatus = checkString(word, matchString)
  }
  return returnStatus
};

export const getYearOptions = (earliestYear: number) => {
  var yearDD = [];
  var currentYear = new Date().getFullYear();
  while (currentYear >= earliestYear) {
    yearDD.push({ value: currentYear, label: currentYear })
    currentYear = currentYear - 1;
  }
  return yearDD
}

export const getDateOptions = (d: any, validate: boolean) => {
  var inpDate = ((d !== undefined && d !== 'unknown') ? d?.split('-') : []);
  var todayDate = new Date();
  var curMonth = todayDate.getMonth() + 1;
  var curYear = todayDate.getFullYear();
  var curDate = todayDate.getDate();
  var inpMonth = (inpDate?.length > 0 && inpDate?.[1] !== '') ? inpDate?.[1] : curMonth;
  var inpYear = (inpDate?.length > 0 && inpDate?.[2] !== '') ? parseInt(inpDate?.[2]) : curYear;
  var monthInNo = inpDate?.length > 0 ? new Date(Date.parse(inpMonth + " 1, " + inpDate?.[2])).getMonth() + 1 : curMonth;
  var starDate = 1;
  var daysInMonth = new Date(inpYear, monthInNo, 0).getDate();
  var dates = [];
  let disable = false;
  while (starDate <= daysInMonth) {
    if (curYear === inpYear && curMonth === monthInNo && curDate < starDate && d !== undefined && d !== 'unknown' && validate) disable = true;
    dates.push({ value: starDate, label: starDate, disable: disable })
    starDate = starDate + 1;
  }
  return dates
}

export const translate = (str: string) => i18n.t(str);

export const validateEmail = (value: string) => {
  let isValid = false;
  isValid = String(value)
    .toLowerCase()
    .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,)
    ? true
    : false;
  return isValid;
};

export const checkInvalidDate = (date: any) => {
  let validDate = true;
  if (Object.prototype.toString.call(date) === "[object Date]") {
    // it is a date      
    if (isNaN(date)) {
      validDate = false;      
    } else {
      // date object is valid
    }
  } else {
    // not a date object
  }
  return validDate;
}

export const validateNumberAllZero = (value: any) => {
  let isValid = false;
  var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  isValid = (
      isNaN(value) || 
      value.trim().match(/^0+$/) || 
      value.includes('.') ||
      (parseInt(value) < 0) ||
      format.test(value)
    )
    ? true
    : false;

  return isValid;
};

export const validateOnlySpace = (value: any) => {
  let isValid = false;
  const regex = /^\s+$/;
  isValid = regex.test(String(value))
    ? false
    : true;

  return { status: isValid, error: i18n.t(PLEASE_ENTER_THE_VALUE) };
}

export const trimWhiteSpaces = (value: any) => {
  const trimmedVAlue = value?.trim()
  return trimmedVAlue;
};

export const findProblemTranslateKey = (value: any, options: DropdownOption[]) => {
  let returnVal = '';
  if(value){
    let selectedOption = options.filter((option: any) => option.value === value);    
    if(selectedOption.length !== 0)
    {
      returnVal = selectedOption[0]['label'];
    }
  }
  
  return returnVal;
};

export const setAddress = (adress: any, arr: any) => {
  const addKey = ['Label', 'Municipality', 'Region', 'PostalCode', 'Country']
  arr.forEach((element: Function, idx: number) => {
    let setAddress = adress[addKey[idx]] ? adress[addKey[idx]] : undefined
    if (addKey[idx] === 'Label') {
      let address1 = adress.Label.split(adress.Municipality);
      address1 = address1[0].replace(/,\s*$/, "");
      setAddress = address1
    }

    element(setAddress)
  });
};

export const getCountryCode = (country:string) => countryCode[country];

export const resetField = (arr:any) => arr.forEach((element: Function) => { element(undefined) });

export const getTrimmedLowerCase = (val: any) => val?.trim().toLocaleLowerCase();